import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from "react-router-dom";
import Home, {Query} from "./pages/home";

import 'mdui'
import 'mdui/mdui.css'
import {setColorScheme, setTheme} from "mdui";

setColorScheme('#68548E');
setTheme("auto")

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={createBrowserRouter(createRoutesFromElements(
        <Route>
            <Route path={"/"} element={<Home/>}/>
            <Route path={"/query/:sn"} element={<Query/>}/>
        </Route>
    ))}/>
);